import { createStore, withProps } from '@ngneat/elf';
import { persistState, localStorageStrategy } from '@ngneat/elf-persist-state';
import { PermissionFlags } from './auth.types';

/** Profile from the LoginWeb response. `S3Config` is intentionally not persisted. */
export interface User {
    id: number | string;
    /** Login name. */
    userName: string;
    /** Display name (falls back to userName). */
    name: string;
    designation: string | null;
    employeeId: number | string | null;
    supervisor: string | null;
    supervisorId: number | string | null;
    companyId: number | string | null;
    folderPath: string | null;
}

export interface AuthState {
    user: User | null;
    token: string | null;
    refreshToken: string | null;
    /** Primary role (first of `roles`), shown in the UI. */
    role: string | null;
    roles: string[];
    /** Normalized module key (see moduleKey()) → CRUD flags, built from the login `Permission[]`. */
    permissions: Record<string, PermissionFlags>;
    /** The superadmin login: every module and action is allowed. */
    isSuperAdmin: boolean;
}

const authStore = createStore(
    { name: 'auth' },
    withProps<AuthState>({
        user: null,
        token: null,
        refreshToken: null,
        role: null,
        roles: [],
        permissions: {},
        isSuperAdmin: false,
    })
);

export const persist = persistState(authStore, {
    // v3: adds isSuperAdmin; drops older sessions so everyone logs in again with the new permissions.
    key: 'auth-v3',
    storage: localStorageStrategy,
});

export { authStore };
